module.exports = __webpack_public_path__ + "static/transfer_request5-d052758e46a472b88698aa542ff81fac.png";